// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__Dxe-s","colMaxWidth":"Table_colMaxWidth__LmJHA"};